var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import { HttpMethods } from 'tagwalk-api-client/assets/js/common/enums';
import { StatusEnum } from 'tagwalk-api-client/assets/js/Types/Enums';
import { getThrownError } from 'tagwalk-api-client/assets/js/errorHandler';
import { toast } from 'react-toastify';
import Loader from 'tagwalk-api-client/assets/js/Components/Loader';
import { CSSTransition } from 'react-transition-group';
import { FreeReport } from './freeReport';
import { PaidReport } from './paidReport';
import { translate } from '@js/common/helpers';
import InfiniteScroll from 'tagwalk-api-client/assets/js/Components/InfiniteScroll';
import { fetchApi } from '@js/common/helpers';
import { DescriptionBlock } from "./descriptionBlock";
var paginationSize = 10;
var List = function (_a) {
    var cdn = _a.cdn, unreadReportsSlugs = _a.unreadReportsSlugs;
    var _b = React.useState([]), reports = _b[0], setReports = _b[1];
    var _c = React.useState(true), isLoading = _c[0], setIsLoading = _c[1];
    var _d = React.useState(1), pagination = _d[0], setPagination = _d[1];
    var _e = React.useState(0), totalCount = _e[0], setTotalCount = _e[1];
    var fetchReports = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, data_1, totalCount_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (reports.length !== 0 && isLoading) {
                        return [2];
                    }
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, 6, 7]);
                    return [4, fetchApi('api_report_list', HttpMethods.get, {
                            from: paginationSize * (pagination - 1),
                            size: paginationSize,
                            status: StatusEnum.enabled
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok) return [3, 4];
                    return [4, response.json()];
                case 3:
                    data_1 = _a.sent();
                    totalCount_1 = response.headers.get('X-Total-Count');
                    setReports(function (prevState) {
                        return __spreadArray(__spreadArray([], prevState, true), data_1, true);
                    });
                    if (totalCount_1) {
                        setTotalCount(parseInt(totalCount_1));
                    }
                    return [2];
                case 4:
                    toast.error(response.status.toString());
                    return [3, 7];
                case 5:
                    error_1 = _a.sent();
                    toast.error(getThrownError(error_1));
                    return [3, 7];
                case 6:
                    setIsLoading(false);
                    return [7];
                case 7: return [2];
            }
        });
    }); };
    React.useEffect(function () {
        fetchReports();
    }, [pagination]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DescriptionBlock, null),
        React.createElement("div", { className: "reports-container" },
            React.createElement(Loader, { isLoading: isLoading && reports.length === 0 }),
            React.createElement(CSSTransition, { in: true, timeout: 1000, classNames: "reports-list" },
                React.createElement("div", { className: "reports-list" },
                    reports.length > 0
                        ?
                            reports.map(function (report, index) {
                                return report.price === null || report.payment_link === null
                                    ? React.createElement(FreeReport, { report: report, cdn: cdn, key: index, isNewReport: unreadReportsSlugs && Object.values(unreadReportsSlugs).includes(report.slug) })
                                    : React.createElement(PaidReport, { report: report, cdn: cdn, key: index, isNewReport: unreadReportsSlugs && Object.values(unreadReportsSlugs).includes(report.slug) });
                            })
                        : React.createElement("div", { id: "no-results" }, translate('report.no_results', {}, 'app')),
                    totalCount > reports.length && (React.createElement(InfiniteScroll, { callback: function () {
                            setPagination(pagination + 1);
                        }, loading: isLoading, seeMoreCount: totalCount - paginationSize * pagination, useIntersection: false })))))));
};
export { List };
